// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/webstrap/type/type.scss
 ** module id = 60
 ** module chunks = 0 1
 **/